import { render, staticRenderFns } from "./BButtonUploadEvidence.vue?vue&type=template&id=659d7f35&scoped=true&"
import script from "./BButtonUploadEvidence.vue?vue&type=script&lang=js&"
export * from "./BButtonUploadEvidence.vue?vue&type=script&lang=js&"
import style0 from "./BButtonUploadEvidence.vue?vue&type=style&index=0&id=659d7f35&lang=scss&scoped=true&"
import style1 from "./BButtonUploadEvidence.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d7f35",
  null
  
)

export default component.exports